import { useCallback } from 'react';
import { useIsMounted } from 'js/hooks/useIsMounted';
import { useGetErrorResponseMessage } from 'js/hooks/server';

import * as server from './server';
import * as helpers from '../helpers';
import * as actions from '../store/actions';
import { useDynamicReducerDispatch } from '../store';

export const useFetchComponentConfig = () => {
    const isMounted = useIsMounted();
    const dispatch = useDynamicReducerDispatch();
    const getErrorResponseMessage = useGetErrorResponseMessage();

    return useCallback(() => {
        dispatch(actions.toggleLoading(true));
        dispatch(actions.setError(''));

        (async () => {
            try {
                const response = await server.getRgConfiguration();
                const enabledLimitTypes = helpers.parseEnabledLimitTypes(response.data);

                isMounted() && dispatch(actions.updateEnabledLimitTypes(enabledLimitTypes));
            } catch (error) {
                isMounted() && dispatch(actions.setError(getErrorResponseMessage(error)));
            } finally {
                isMounted() && dispatch(actions.toggleLoading(false));
            }
        })();
    }, [dispatch, isMounted, getErrorResponseMessage]);
};
